import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import README from './README.md';
import { Hint } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "digmaker-ui"
    }}>{`digmaker-ui`}</h1>
    <p>{`digimaker-ui provides react ui components for Digimaker CMF. It provides features like create, edit, delete, actions and other editorial features.`}</p>
    <p>{`Check our sample projects`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/digimakergo/dmdemo/tree/master/web/admin/src"
        }}>{`admin`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/digimakergo/dmdemo/tree/master/web/app/src"
        }}>{`app`}</a></li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm -i digimaker-ui

// Note. for npm version > 7 you may need to run
// npm -i digimaker-ui --legacy-peer-deps
`}</code></pre>
    <p>{`Read `}<a parentName="p" {...{
        "href": "./use-digimaker-ui"
      }}>{`Use digimaker-ui`}</a>{` for how to use it.`}</p>
    <p>{`Read `}<a parentName="p" {...{
        "href": "./actions/Implement"
      }}>{`extend actions`}</a>{` and `}<a parentName="p" {...{
        "href": "./FieldTypes"
      }}>{`implement your own field types`}</a>{`.`}</p>
    <h3 {...{
      "id": "common-components"
    }}>{`Common components`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// import example
import {Main} from 'digimaker-ui';
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./List"
            }}>{`List`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List contents`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./Main"
            }}>{`Main`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Main page for editorial site`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./DMInit"
            }}>{`DMInit`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Initialize all components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./TreeNode"
            }}>{`TreeNode`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Show content in tree`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./Browse"
            }}>{`Browse`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Browse contents`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./util"
            }}>{`util`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Utility`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./RenderFields"
            }}>{`RenderFields`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rendering fields in view/edit mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "./FileUpload"
            }}>{`FileUpload`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Upload file to server`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "actions"
    }}>{`Actions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//import example
import {Delete} from 'digimaker-ui/actions';
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Note`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Copy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Copy a content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Move`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SetPriority`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set priority`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SetToTop`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Set to top`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter above list`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`User`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DisableUser`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Diable/Enable current user`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "action-for-routing"
    }}>{`Action for routing`}</h3>
    <Hint type="info" variant="outer" mdxType="Hint">
Note: It's not possible to configure below to action, but with wrapper(eg. dialog to implemment `ActionProps`) it's possible.
    </Hint>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Create`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Edit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Edit a content`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      